import React, { useMemo, useState } from "react";
import Styles from "./index.module.scss";
import WeekCalendar from "../../../../main/components/WeekCalendar";
import { Spin } from "antd";
import _ from "underscore";
import moment from "moment/moment";
import useRequest from "../../../../../utils/useRequest";
import { getCourseData, toNumber } from "../../../../../service/service";
import useCurrentDate from "../../../../../utils/useCurrentDate";
import WeekPicker from "../../../../main/components/WeekPicker";

interface Props {
    name?: string;
}
const evaluationFlag = "1";

const Index = ({ name }: Props) => {
    const { theWeek, startDate: startDateOfBatch } = useCurrentDate();
    const [week, setWeek] = useState(toNumber(theWeek));

    // 计算所选择周的起止时间
    const [startDate, endDate] = useMemo(() => {
        const startDate = moment(startDateOfBatch)
            .startOf("week")
            .add(week - 1, "weeks")
            .format("YYYYMMDD");
        const endDate = moment(startDate).add(6, "d").format("YYYYMMDD");
        return [startDate, endDate];
    }, [week, startDateOfBatch]);

    const [CourseData, { loading }] = useRequest(
        () => getCourseData({ name, evaluationFlag }),
        {},
        [name, evaluationFlag]
    );

    // 筛选当前周的排课
    const data = useMemo(() => {
        if (!CourseData) return [];

        const weekData = CourseData.filter(
            item => item.date <= endDate && item.date >= startDate
        );
        const groupData = _.groupBy(weekData, "date");
        const newData = [];

        for (let i = 0; i < 7; i++) {
            const date = moment(startDate).add(i, "d").format("YYYYMMDD");
            newData.push({ day: i.toString(), courses: groupData[date] || [] });
        }

        return newData;
    }, [CourseData, startDate, endDate]);

    return (
        <div className={Styles.root}>
            <div className={Styles.top}>
                <WeekPicker
                    showList={false}
                    week={week}
                    currentWeek={toNumber(theWeek)}
                    onChange={setWeek}
                />
            </div>
            <Spin spinning={loading}>
                <div className={Styles.over}>
                    <div className={Styles.stop} />
                    <WeekCalendar
                        type="my"
                        data={data}
                        startDate={startDate}
                        endDate={endDate}
                        showMore={false}
                    />
                </div>
            </Spin>
        </div>
    );
};

export default Index;
